import { createFileRoute } from '@tanstack/react-router'

import ApiKeys from '@/features/Admin/ApiKeys'

export const Route = createFileRoute('/_authenticated/admin/api-keys')({
    component: RouteComponent,
})

function RouteComponent() {
    return <ApiKeys />
}
